(function () {
  function formatGBP(cents) {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
  }

  function initTuttiAccessories() {
    document.querySelectorAll('[data-tutti-accessories]').forEach(function (wrapper) {
      if (wrapper.dataset.tuttiInitialized === 'true') return;

      var formId = wrapper.dataset.formId;
      var form = document.getElementById(formId);
      if (!form) return;

      wrapper.dataset.tuttiInitialized = 'true';

      var productContainer =
        wrapper.closest('[data-product-container]') ||
        wrapper.closest('.product-section') ||
        document;

      var displayedPrice =
        productContainer.querySelector('[data-product-price]') ||
        document.querySelector('[data-product-price]');

      var basePriceCents = parseInt(wrapper.dataset.basePriceCents || '0', 10);

      function updateDisplayedTotal() {
        var total = basePriceCents;
        wrapper.querySelectorAll('[data-optional-accessory]:checked').forEach(function (radio) {
          total += parseInt(radio.dataset.priceCents || '0', 10);
        });
        if (displayedPrice) displayedPrice.textContent = formatGBP(total);
      }

      wrapper.querySelectorAll('[data-optional-accessory]').forEach(function (radio) {
        radio.addEventListener('change', updateDisplayedTotal);
      });

      updateDisplayedTotal();

      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var addButton = form.querySelector('[data-add-to-cart]');
        var errorBox = wrapper.querySelector('[data-optional-accessory-error]');
        var variantSelect = form.querySelector('[name="id"]');

        if (!variantSelect || !variantSelect.value) return;

        if (errorBox) {
          errorBox.hidden = true;
          errorBox.textContent = '';
        }

        var quantityInput =
          document.querySelector('[form="' + formId + '"][name="quantity"]') ||
          form.querySelector('[name="quantity"]');

        var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
        if (!quantity || quantity < 1) quantity = 1;

        var items = [{ id: Number(variantSelect.value), quantity: quantity }];

        wrapper.querySelectorAll('[data-optional-accessory]:checked').forEach(function (radio) {
          var variantId = Number(radio.dataset.variantId);
          if (variantId) items.push({ id: variantId, quantity: 1 });
        });

        if (addButton) {
          addButton.disabled = true;
          addButton.classList.add('btn--loading');
        }

        try {
          var root =
            window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/';

          var response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: items })
          });

          var result = await response.json();
          if (!response.ok) {
            throw new Error(
              result.description ||
              result.message ||
              'Unable to add the selected products to the cart.'
            );
          }

          window.location.href = root + 'cart';
        } catch (error) {
          if (errorBox) {
            errorBox.textContent =
              error.message || 'Unable to add the selected products to the cart.';
            errorBox.hidden = false;
          }
          if (addButton) {
            addButton.disabled = false;
            addButton.classList.remove('btn--loading');
          }
        }
      }, true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTuttiAccessories);
  } else {
    initTuttiAccessories();
  }

  document.addEventListener('shopify:section:load', initTuttiAccessories);
})();
